// extracted by mini-css-extract-plugin
export var closer = "style-module--closer--b0ce8";
export var section = "style-module--section--604e4";
export var switchWrapper = "style-module--switch-wrapper--d7948";
export var text = "style-module--text--2f73a";
export var textButton = "style-module--text-button--b1149";